module.exports = __webpack_public_path__ + "images/emoji/abc.8c4f1c2f7d2d21b02eb6.png";